import { Modal, Form, Input, Button, Select } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const { TextArea } = Input;

const MarkAsLostModal = ({
  draggableLead,
  updateLead,
  type,
  setType,
  setStatus,
  handleCancel,
}) => {
  const unqualifiedReasons = useSelector(
    (state) => state.leadListingReducer.unqualifiedReasons,
  );
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (type) {
      setVisible(true);
    }
  }, [type]);

  const onCancel = () => {
    setVisible(false);
    setType();
    setStatus();
    handleCancel();
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={() => {
        onCancel();
      }}
      className="delete-popup"
      footer={<></>}
    >
      <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-sm tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50 uppercase tw-tracking-wider">
        {type === "Closed Lost"
          ? "Mark Lead as Lost"
          : "Mark Lead as Unqualified"}
      </div>
      <div className="tw-px-6 tw-pt-5">
        <div className="tw-bg-slate-50/50 tw-border tw-border-solid tw-border-slate-100/60 tw-rounded-xl tw-p-3.5 tw-flex tw-items-center tw-justify-between">
          <span className="tw-text-xs tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-wider">
            Lead Name
          </span>
          <span className="tw-text-xs tw-font-bold tw-text-slate-700">
            {draggableLead?.fullname}
          </span>
        </div>
      </div>

      <MarkAsLost
        status={type}
        onSubmit={(value) => {
          updateLead({
            ...draggableLead,
            ...value,
            unqualifiedReason:
              type === "Closed Lost"
                ? null
                : {
                    id: unqualifiedReasons?.find(
                      (d) => d?.reason === value?.unqualifiedReason,
                    )?.id,
                    reason: value?.unqualifiedReason,
                  },
            status: type === "Closed Lost" ? 17 : 18,
          });
          onCancel();
        }}
        handleCancel={onCancel}
      />
    </Modal>
  );
};

export default MarkAsLostModal;

const MarkAsLost = ({ onSubmit, handleCancel, status }) => {
  const [form] = Form.useForm();
  const [reason, setReason] = useState();
  const unqualifiedReasons = useSelector(
    (state) => state.leadListingReducer.unqualifiedReasons,
  );

  return (
    <Form
      form={form}
      layout="vertical"
      className="tw-mt-2"
      onFinish={(values) => {
        onSubmit(values);
        form.resetFields();
        setReason();
      }}
    >
      <div className="tw-p-6 tw-pt-3">
        {status === "Closed Lost" && (
          <div className="tw-flex tw-flex-col tw-gap-4">
            <Form.Item
              name="lostReason"
              label={
                <span className="tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">
                  Lost Reason
                </span>
              }
              rules={[{ required: true, message: "Please add a reason" }]}
              className="tw-mb-0"
            >
              <Input
                className="common-input !tw-rounded-lg !tw-h-[38px] !tw-border-slate-200 focus:!tw-border-theme focus:!tw-shadow-none"
                placeholder="Enter reason"
              />
            </Form.Item>

            <Form.Item
              name="comments"
              label={
                <span className="tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">
                  Comments
                </span>
              }
              className="tw-mb-0"
            >
              <TextArea
                className="common-input !tw-rounded-lg !tw-border-slate-200 focus:!tw-border-theme focus:!tw-shadow-none"
                rows={3}
                placeholder="Enter comments"
              />
            </Form.Item>
          </div>
        )}

        {status === "Un-Qualified" && (
          <div className="tw-flex tw-flex-col tw-gap-4">
            <Form.Item
              name="unqualifiedReason"
              label={
                <span className="tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">
                  Reason for Unqualification
                </span>
              }
              rules={[{ required: true, message: "Please select a reason" }]}
              className="tw-mb-0"
            >
              <Select
                placeholder="Select reason"
                options={unqualifiedReasons?.map((d) => ({
                  label: d.reason,
                  value: d.reason,
                }))}
                onChange={(value) => {
                  form.setFieldsValue({
                    unqualifiedReason: value,
                    unqualifiedReasonsOthers: undefined,
                  });
                  setReason(value);
                }}
                className="tw-h-[38px]"
              />
            </Form.Item>

            {reason === "Others" && (
              <Form.Item
                name="unqualifiedReasonsOthers"
                label={
                  <span className="tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">
                    Add Reason
                  </span>
                }
                rules={[{ required: true, message: "Please add a reason" }]}
                className="tw-mb-0"
              >
                <TextArea
                  className="common-input !tw-rounded-lg !tw-border-slate-200 focus:!tw-border-theme focus:!tw-shadow-none"
                  rows={3}
                  placeholder="Enter unqualification reason"
                />
              </Form.Item>
            )}
          </div>
        )}
      </div>
      <div className="tw-flex tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100/60 tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-3">
        <Button
          className="!tw-h-[38px] !tw-rounded-lg !tw-border-slate-200 !tw-bg-white !tw-px-5 !tw-text-xs !tw-font-bold !tw-text-slate-500 hover:!tw-border-slate-300 hover:!tw-text-slate-700 tw-transition-all tw-duration-200"
          onClick={() => {
            handleCancel();
            form.resetFields();
            setReason();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          className="!tw-bg-rose-600 !tw-border-rose-600 !tw-text-white !tw-h-[38px] !tw-rounded-lg !tw-px-5 !tw-text-xs !tw-font-bold tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200"
        >
          {status === "Closed Lost" ? "Mark as lost" : "Mark as unqualified"}
        </Button>
      </div>
    </Form>
  );
};
